import type { BduiTranslations } from '../interfaces/bdui';

export const bduiTranslations: BduiTranslations = {
  placeholder_select: 'Selecciona una opción',
  placeholder_multiselect: 'Selecciona una o más opciones',
  placeholder_tag_list: 'Escribe y pulsa Enter para añadir',
  help_tag_list: 'Pulsa Enter o coma para añadir. Haz clic en X para quitar.',
  placeholder_kv_key: 'Clave',
  placeholder_kv_value: 'Valor',
  action_kv_add: 'Agregar fila',
  action_kv_remove: 'Quitar fila',
  action_repeater_add: 'Agregar elemento',
  action_repeater_remove: 'Eliminar elemento',
  repeater_empty: 'Aún no hay elementos.',
  repeater_item_title: 'Elemento {{index}}',

  validation_required: 'Este campo es requerido.',
  validation_min_length: 'Debe tener al menos {{length}} caracteres.',
  validation_max_length: 'Debe tener como máximo {{length}} caracteres.',
  validation_min: 'Debe ser al menos {{value}}.',
  validation_max: 'Debe ser como máximo {{value}}.',
  validation_invalid_option: 'Elige una de las opciones disponibles.',

  sections_nav_label: 'Secciones',
  placeholder_search: 'Buscar…',

  json_help:
    'Edita la configuración cruda. Útil para cambios masivos o cuando un asistente IA te genera el JSON. Guardar usa la misma lógica de diff que el formulario.',
  json_parse_error: 'JSON inválido: {{message}}',
  json_position: 'línea {{line}}, columna {{col}}',
  json_copy: 'Copiar',
  json_copied: 'Copiado al portapapeles.',
  json_format: 'Formatear',
  json_validation_title: 'Validación contra el esquema',
  json_validation_empty: 'Sin problemas con el esquema.',
  json_copy_error: 'No se pudo copiar al portapapeles.',
};
